import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { getLocationParamer } from "@/utils/common";

const ErrorPopupRacing = ({
    showErrorPopup,
    className = "ErrorPopupRacing",
    title,
    content,
    buttonText,
    buttonConfirmText,
    errorCallback = () => {},
    isShowButton = false,
}) => {
    const { t } = useTranslation();
    const type = getLocationParamer("bg");
    console.log(buttonConfirmText, "buttonConfirmText");
    // 'DARK'
    return (
        <div
            className={`${className} ${type === "DARK" ? "DARK" : ""}  ${
                buttonConfirmText ? "multiple" : ""
            }`}
        >
            <div className={`${className}-main`}>
                {title && (
                    <div className={`${className}-title`}>{t(title)}</div>
                )}
                {isShowButton ? (
                    <div
                        className={`${className}-content`}
                        dangerouslySetInnerHTML={{
                            __html: t(typeof content === 'string' ? content : content?.msg, { code: content?.code } ).replace('()',''),
                        }}
                    ></div>
                ) : (
                    <div className={`${className}-content`}>{t(typeof content === 'string' ? content : content?.msg, { code: content?.code } ).replace('()','')}</div>
                )}
            </div>
            <div className={`${className}-button-wapper`}>
                {buttonText && (
                    <div
                        className={`${className}-button`}
                        onClick={() => {
                            errorCallback?.();
                            showErrorPopup("");
                        }}
                    >
                        {t(buttonText)}
                    </div>
                )}
                {buttonConfirmText ? (
                    <div
                        onClick={() => {
                            errorCallback?.();
                            showErrorPopup("");
                        }}
                        className={`${className}-confirm-button ${className}-button`}
                    >
                        {t(buttonConfirmText)}
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
};

export default ErrorPopupRacing;
